import type { Offer } from '../../lib/offers';
import { OfferCard } from './OfferCard';
import * as S from './styles';

interface OffersStripProps {
  offers: Offer[];
  /** عنوان القسم — احذفه للنسخة المضغوطة داخل ملخص الطلب */
  title?: string;
  /** نسخة مضغوطة (صفحة الدفع/النجاح): بدون امتداد لحواف الشاشة */
  compact?: boolean;
  /** إظهار شريط التقدّم نحو الحد الأدنى — حيث توجد سلة فعلية */
  showProgress?: boolean;
  onSelect?: (offer: Offer) => void;
  /** لم تصل بيانات المتجر بعد — نعرض هيكلاً عظمياً بدل قفزة تخطيط */
  isLoading?: boolean;
}

export function OffersStrip({
  offers,
  title,
  compact,
  showProgress,
  onSelect,
  isLoading,
}: OffersStripProps) {
  // في النسخة المضغوطة لا نعرض هيكلاً عظمياً: ملخص الطلب يعرض "—" أصلاً أثناء التحميل
  if (isLoading && compact) return null;

  if (isLoading) {
    return (
      <S.StripSection $compact={compact} aria-hidden="true">
        {title && <S.StripTitle>{title}</S.StripTitle>}
        <S.StripScroller $compact={compact}>
          <S.Slot $compact={compact} $count={2}>
            <S.Skeleton />
          </S.Slot>
          <S.Slot $compact={compact} $count={2}>
            <S.Skeleton />
          </S.Slot>
        </S.StripScroller>
      </S.StripSection>
    );
  }

  if (offers.length === 0) return null;

  return (
    <S.StripSection $compact={compact} aria-label="العروض المتاحة">
      {title && <S.StripTitle>{title}</S.StripTitle>}
      <S.StripScroller $compact={compact}>
        {offers.map((offer) => (
          <S.Slot key={offer.id} $compact={compact} $count={offers.length}>
            <OfferCard offer={offer} onSelect={onSelect} showProgress={showProgress} />
          </S.Slot>
        ))}
      </S.StripScroller>
    </S.StripSection>
  );
}

export default OffersStrip;
